import request from '@/mixins/request'

export default {
  mixins: [request],

  methods: {
    updateCurrentVoyage(mmsi) {
      return this.$api
        .post('/trace/aiseventops/updateCurrentVoyage', `mmsi=${mmsi}`, {
          baseURL: '/',
        })
        .then(resp => {
          if (resp.data.status === 1) {
            return Promise.resolve(resp.data.content)
          } else {
            return Promise.reject(resp.data.message || '更新当前航次错误')
          }
        })
    },

    getVesselByName(name) {
      return this.$api
        .get('/schedules/baseVessel/getVesselByName', {
          params: { name: name || '' },
        })
        .then(resp => {
          if (resp.data.status === 1) {
            return resp.data.content || []
          } else {
            return Promise.reject(resp.data.message || 'error')
          }
        })
    },

    queryHistoryVoyageStat(ms) {
      return this.$api.post(
        '/trace/aiseventops/queryHistoryVoyageStat',
        ms || [],
        { baseURL: '/' }
      )
    },
  },
}
